// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '2cfac35bfce4d257d1f8d5635b375096078232e8';
export const BUILD_NUMBER = '260';
export const BUILD_TIMESTAMP = '2026-10-06T08:49:37.438Z';
